import { render, staticRenderFns } from "./viewInviteList.vue?vue&type=template&id=767e2656&scoped=true&"
import script from "./viewInviteList.vue?vue&type=script&lang=js&"
export * from "./viewInviteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e2656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767e2656')) {
      api.createRecord('767e2656', component.options)
    } else {
      api.reload('767e2656', component.options)
    }
    module.hot.accept("./viewInviteList.vue?vue&type=template&id=767e2656&scoped=true&", function () {
      api.rerender('767e2656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/communication/components/viewInviteList.vue"
export default component.exports